// emailService.js
import emailjs from '@emailjs/browser';

const sanitize = (value) => {
  if (typeof value === 'string') {
    return value.trim() === '' ? 'N/A' : value;
  }
  if (value === undefined || value === null) {
    return 'N/A';
  }
  return value;
};


const SERVICE_ID = 'service_qs9v96e';
const ADMIN_TEMPLATE_ID = 'template_fa7qndd';
const USER_TEMPLATE_ID = 'template_vghzjt8';

// SubService template IDs
const SUBSERVICE_ADMIN_TEMPLATE_ID = 'template_mo5pzwu';
const SUBSERVICE_USER_TEMPLATE_ID = 'template_bz16ror';

// Motor vehicle accident form

const MotorVehicle_ADMIN_TEMPLATE_ID = 'template_rtu70jb'
const MotorVehicle_USER_TEMPLATE_ID = 'template_xfveyie'

// Talcum Powder form
const TalcumPowder_ADMIN_TEMPLATE_ID = 'template_vf1p4wh'
const TalcumPowder_USER_TEMPLATE_ID = 'template_wnvmf8b'


const PUBLIC_KEY = 'LHN36zibZMdIZeRb7';

emailjs.init(PUBLIC_KEY);

// Function to get the initial landing URL
let initialLandingUrl = null;

const getSourceUrl = () => {
  if (typeof window === "undefined") return "Unknown";

  // If we haven't stored the initial URL yet, store it
  if (!initialLandingUrl) {
    initialLandingUrl = window.location.href;
  }

  return initialLandingUrl;
};

// Function to get IP address
const getIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Failed to get IP address:", error);
    return "IP address not available";
  }
};

// Function to clean phone number to 10 digits
const cleanPhoneNumber = (phone) => {
  if (!phone) return '';
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '');
  // Return last 10 digits if more than 10, otherwise return all digits
  return digits.length > 10 ? digits.slice(-10) : digits;
};

// Lead Prosper API function for Talcum Powder
export const sendToLeadProsper = async (formData, trustedFormData) => {
  try {
    const ipAddress = await getIPAddress();

    const leadProsperData = {
      lp_campaign_id: "30996",
      lp_supplier_id: "96284",
      lp_key: "goda5jnrux65q",
      lp_action: "",
      lp_subid1: "",
      lp_subid2: "",
      Source: "",

      // Form fields mapped correctly
      first_name: formData.fullName|| "",
      email: formData.email || "",
      number1: cleanPhoneNumber(formData.phone) || "",
      street: formData.address|| "",
      city: "",
      zip: formData.zipcode || "",
      state: formData.state|| "",

      // TrustedForm data
      verification_id: trustedFormData.xxTrustedFormCertUrl || "",

      notes: "",
      external_id: "",
      ip_adress: ipAddress,

      Visit_Date: "",
    };

    const response = await fetch("https://api.leadprosper.io/direct_post", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(leadProsperData),
    });

    const result = await response.json();
    console.log("Lead Prosper API Response:", result);
    return result;

  } catch (error) {
    console.error("Failed to send to Lead Prosper API:", error);
    return { status: "ERROR", message: error.message };
  }
};



export const sendLandingPageFormEmail = async (formData, trustedFormData) => {
  try {
    const ipAddress = await getIPAddress();

    const templateParams = {
      from_name: formData.fullName,
      from_email: "reachus@connectwithattorney.com",
      email: formData.email,
      phone_number: `${formData.countryCode}${formData.phone}`,
      zipcode: formData.zipcode || "N/A",
      street_address: formData.address || "N/A",
      ip_address: ipAddress,
      page_source: getSourceUrl(),
      subject: "New Landing Page Form Submission",

      // TrustedForm fields (matching your passed object)
      xxTrustedFormCertUrl: trustedFormData.xxTrustedFormCertUrl,
      xxTrustedFormPingUrl: trustedFormData.xxTrustedFormPingUrl,
      xxTrustedFormCertToken: trustedFormData.xxTrustedFormCertToken,

      submission_date: new Date().toLocaleDateString(),
    };

    // Send admin notification
    const response = await emailjs.send(
      "service_qs9v96e",
      "template_qdqhtov",
      templateParams
    );

    // Send confirmation email to user
    if (formData.email) {
      try {
        await sendConfirmationEmail(formData.email, "landing page form", {
          name: formData.fullName,
        });
      } catch (confirmationError) {
        console.error("Failed to send confirmation email:", confirmationError);
      }
    }

    return { success: true, response };
  } catch (error) {
    console.error("Failed to send email:", error);
    return { success: false, error };
  }
};

const sendConfirmationEmail = async (userEmail, formType, formData) => {
  try {
    const templateParams = {
      to_email: userEmail,
      from_email: "reachus@connectwithattorney.com",

      // Use name from formData (fullName) if available
      to_name: formData.name || formData.fullName || "Valued Customer",

      from_name: "ConnectWithAttorney",
      subject: `Thank you for your ${formType} submission`,

      message: `Thank you for submitting your ${formType}. We have received your information and will get back to you soon.`,

      name: formData.name || formData.fullName || "",
      form_type: formType,
      submission_date: new Date().toLocaleDateString(),
      reply_to: "reachus@connectwithattorney.com",

      // ensure template uses correct email
      user_email: userEmail,
    };

    const response = await emailjs.send(
      "service_9pv809e",
      "template_b9toxto",
      templateParams
    );

    return { success: true, response };
  } catch (error) {
    console.error("Failed to send confirmation email:", error);
    return { success: false, error };
  }
};



